<template>
  <div style="width: 100%">
    <div v-for="item in bedBathParams" :key="item.name" class="bed-bath-params">
      <div class="item-type text-uppercase">
        {{ item.name }}
      </div>
      <v-layout wrap>
        <v-flex xs1 />
        <v-flex
          v-for="option in item.options"
          :key="option.text"
          xs2
          class="number-selector"
          :class="{
            selected: lastNewQuery.query[item.name] === option.value,
            result: searchObject.searchResult && !filterGroup
          }"
          @click.stop="$emit('bed-bath-selected', { type: item.name, option })"
        >
          {{ option.text }}
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { searchOptions } from '../../../common/searchPropertyConst'

export default {
  props: {
    lastNewQuery: {
      type: Object,
      required: true
    },
    searchObject: {
      type: Object,
      required: true
    },
    filterGroup: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      bedBathParams: [
        { name: 'Beds', options: searchOptions.dropdownNoOfBeds },
        { name: 'Baths', options: searchOptions.dropdownNoOfBaths }
      ]
    }
  }
}
</script>

<style lang="sass" scoped>
.bed-bath-params
  display: flex
  align-items: center
  padding: 1rem 1.5rem
  .item-type
    width: 20%
    text-align: left

.number-selector
  cursor: pointer
  border-radius: 0.5rem
  border: 0.1rem solid transparent
  font-size: 1.4rem
  text-align: center !important
  &.selected
    border: 0.1rem solid $hwayzBlack
    &.result
      border: 0.1rem solid $hwayzKellyGreen
      color: $hwayzWhite
      background-color: $hwayzKellyGreen
</style>
